import { Icon } from "@iconify/react";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AuthUser from "../../../Hooks/authUser";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import Payment from "../DoctorBilling/Payment";

const LicensePatient = ({
  patientId,
  patient,
  packages,
  refetch,
  setRefetch,
}) => {
  const { userInfo } = AuthUser();
  const [user, setUser] = useState(null);
  const [pack, setPack] = useState("");
  const [anaglyph, setAnaglyph] = useState(false);

  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pinCode, setPinCode] = useState("");

  const today = moment();
  const issueDate = moment().format("YYYY-MM-DD");
  const expireDate = today.add(pack ? pack : 1, "days").format("YYYY-MM-DD");

  const isExpire = packages?.expireDate
    ? moment(issueDate).isAfter(packages?.expireDate)
    : true;

  const packagePrice = `${(pack === 1 && user?.oneDay ? user?.oneDay : 0) ||
    (pack === 30 && user?.oneMonth ? user?.oneMonth : 0) ||
    (pack === 90 && user?.threeMonth ? user?.threeMonth : 0) ||
    (pack === 180 && user?.sixMonth ? user?.sixMonth : 0)
    }`;
  const totalPrice = Number(
    (pack && packagePrice ? +packagePrice : 0) +
    (anaglyph && user?.anaglyphCost ? +user?.anaglyphCost : 0)
  );

  const isDisable = anaglyph
    ? (address1 && address2 && city && state && pinCode && country) === false
    : false;

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/user/${userInfo?._id}`, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setUser(data?.data));
  }, [userInfo?._id, refetch]);

  const data = {
    userName: patient?.name,
    userEmail: patient?.email,
    userId: patientId,

    referralName: user?.name,
    referralEmail: user?.email,
    referralId: user?._id,
    paymentType: "Cash On Delivery",

    packageName: `${pack} Days Package`,
    packagePrice: Number(packagePrice),
    Anaglyph: anaglyph ? "Yes" : "No",
    anaglyphPrice: (anaglyph ? user?.anaglyphPrice : 0)
      ? user?.anaglyphPrice
      : 0,
    totalDay: pack,
    totalPrice: totalPrice,
    address: {
      city,
      state,
      country,
      address1,
      address2,
      pinCode,
    },

    issueDate: issueDate,
    expireDate: expireDate,
  };

  const handelUpdate = async (pay) => {
    if (packages?.expireDate) {
      await UpdateHooks(
        `https://servercareseebd.careseebd.com/api/v1/package/updatePackage/${packages?._id}`,
        data
      );
      toast?.success(`The package was Updated !`);
    } else {
      await fetch("https://servercareseebd.careseebd.com/api/v1/package/addPackage", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          toast.success("package has been added");
        });
    }
    window.location.reload();
    setRefetch(!refetch);
  };

  return (
    <div className="space-y-6">
      {/* Expiration warning/status banner */}
      <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between p-4 bg-slate-50 border border-slate-100 rounded-xl text-xs font-semibold">
        <div className="flex items-center gap-3">
          {packages?.expireDate ? (
            <>
              <div className="w-2.5 h-2.5 rounded-full bg-secondary shadow-md animate-pulse"></div>
              <p className="text-slate-500">
                Latest Package: <strong className="text-slate-700">{packages?.packageName}</strong>
              </p>
            </>
          ) : (
            <>
              <div className="w-2.5 h-2.5 rounded-full bg-rose-500 shadow-md"></div>
              <p className="text-rose-600">No active package subscription registered.</p>
            </>
          )}
        </div>

        <div className="flex items-center gap-2 text-slate-500">
          <Icon icon="solar:calendar-date-bold" className="text-base text-slate-400" />
          <span>{packages?.expireDate ? `Expires on ${packages.expireDate}` : `Today: ${issueDate}`}</span>
        </div>
      </div>

      {/* Package Selector Cards (If expired) */}
      {isExpire && (
        <div className="space-y-3">
          <h4 className="text-sm font-bold text-slate-500 uppercase tracking-wider">Select Subscription Plan</h4>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              { days: 1, label: "1 Day", toggle: user?.oneDayToggle },
              { days: 30, label: "1 Month", toggle: user?.oneMonthToggle },
              { days: 90, label: "3 Month", toggle: user?.threeMonthToggle },
              { days: 180, label: "6 Month", toggle: user?.sixMonthToggle },
            ].map((pOption) => {
              if (user?.role !== "superAdmin" && !pOption.toggle) return null;
              const isSelected = pack === pOption.days;
              return (
                <button
                  key={pOption.days}
                  onClick={() => setPack(pOption.days)}
                  className={`flex flex-col items-center justify-center p-4 rounded-xl border-2 transition duration-200 ${isSelected
                    ? "border-secondary bg-indigo-50/20 text-secondary"
                    : "border-slate-200 hover:border-slate-350 bg-white text-slate-600"
                    }`}
                >
                  <Icon icon="solar:box-linear" className="text-2xl mb-1" />
                  <span className="text-sm font-bold">{pOption.label}</span>
                </button>
              );
            })}
          </div>

          {/* Anaglyph checkbox toggle */}
          <div className="py-2">
            <label className="inline-flex items-center gap-2 cursor-pointer select-none">
              <input
                checked={anaglyph}
                onChange={(e) => setAnaglyph(e.target.checked)}
                type="checkbox"
                className="w-4 h-4 rounded text-secondary border-slate-300 focus:ring-secondary/20"
              />
              <span className="text-sm font-bold text-slate-650">Include Physical Anaglyph Glasses</span>
            </label>
          </div>
        </div>
      )}

      {/* Main Breakdown Section */}
      {(anaglyph || pack) && (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Items Table & Address Fields */}
          <div className="lg:col-span-8 space-y-6">
            <div className="bg-white border border-slate-200/80 rounded-xl overflow-hidden shadow-sm">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-100">
                    <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Purchased Item</th>
                    <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-center">Qty</th>
                    <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">Amount</th>
                    <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {pack && (
                    <tr className="hover:bg-slate-50/30">
                      <td className="px-6 py-4 text-sm font-bold text-slate-700">
                        {pack} Days Active Package
                      </td>
                      <td className="px-6 py-4 text-sm text-slate-500 text-center font-medium">1</td>
                      <td className="px-6 py-4 text-sm font-extrabold text-slate-750 text-right">
                        ৳ {pack === 1 && user?.oneDay}
                        {pack === 30 && user?.oneMonth}
                        {pack === 90 && user?.threeMonth}
                        {pack === 180 && user?.sixMonth}
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() => setPack("")}
                          className="text-slate-400 hover:text-rose-500 transition duration-150"
                        >
                          <Icon icon="solar:trash-bin-trash-linear" className="text-lg" />
                        </button>
                      </td>
                    </tr>
                  )}
                  {anaglyph && (
                    <tr className="hover:bg-slate-50/30">
                      <td className="px-6 py-4 text-sm font-bold text-slate-700">
                        Physical Anaglyph Eyewear
                      </td>
                      <td className="px-6 py-4 text-sm text-slate-500 text-center font-medium">1</td>
                      <td className="px-6 py-4 text-sm font-extrabold text-slate-750 text-right">
                        ৳ {user?.anaglyphCost ? user?.anaglyphCost : 0}
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() => setAnaglyph(false)}
                          className="text-slate-400 hover:text-rose-500 transition duration-150"
                        >
                          <Icon icon="solar:trash-bin-trash-linear" className="text-lg" />
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Address Form for Anaglyph Delivery */}
            {anaglyph && (
              <div className="space-y-4 bg-slate-50/35 p-5 rounded-2xl border border-slate-100">
                <h5 className="text-xs font-bold text-slate-400 uppercase tracking-wider">Shipping Address (Required for Glasses)</h5>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                  <div>
                    <label className="block text-xs font-bold text-slate-500 mb-1">Address Line 1</label>
                    <input
                      onChange={(e) => setAddress1(e.target.value)}
                      required
                      placeholder="Street address, P.O. box"
                      className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm font-medium text-slate-700"
                      type="text"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-slate-500 mb-1">Address Line 2</label>
                    <input
                      onChange={(e) => setAddress2(e.target.value)}
                      placeholder="Apartment, suite, unit, building"
                      className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm font-medium text-slate-700"
                      type="text"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-slate-500 mb-1">Town / City</label>
                    <input
                      onChange={(e) => setCity(e.target.value)}
                      required
                      placeholder="City name"
                      className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm font-medium text-slate-700"
                      type="text"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-slate-500 mb-1">State / Province</label>
                    <input
                      onChange={(e) => setState(e.target.value)}
                      required
                      placeholder="State or region"
                      className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm font-medium text-slate-700"
                      type="text"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-slate-500 mb-1">Country</label>
                    <input
                      onChange={(e) => setCountry(e.target.value)}
                      required
                      placeholder="Country"
                      className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm font-medium text-slate-700"
                      type="text"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-slate-500 mb-1">Postal / PinCode</label>
                    <input
                      onChange={(e) => setPinCode(e.target.value)}
                      required
                      placeholder="Zip/postal code"
                      className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm font-medium text-slate-700"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Pricing & Checkout summary card */}
          <div className="lg:col-span-4 space-y-4">
            {/* Address review panel */}
            {anaglyph && (address1 || city) && (
              <div className="border border-slate-200 rounded-xl p-5 bg-slate-50/50 space-y-2 text-xs">
                <h5 className="font-bold text-slate-500 uppercase tracking-wider">Delivery Summary</h5>
                <div className="text-slate-600 space-y-1">
                  <p>{address1}</p>
                  {address2 && <p>{address2}</p>}
                  <p>{city}{state ? `, ${state}` : ""}</p>
                  <p>{country}{pinCode ? ` - ${pinCode}` : ""}</p>
                </div>
              </div>
            )}

            {/* Total Cost card */}
            <div className="border border-slate-200 rounded-xl p-6 bg-white space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-sm font-bold text-slate-450 uppercase tracking-wider">Order Total</span>
                <span className="text-xl font-extrabold text-secondary">৳ {totalPrice}</span>
              </div>
              <div className="border-t border-slate-100 my-4"></div>

              {/* Checkout actions */}
              <div className="flex flex-col gap-2">
                {totalPrice ? (
                  <div className="flex flex-col gap-2">
                    <Payment
                      data={data}
                      packages={packages}
                      patient={patient}
                      isDisable={isDisable}
                    />

                    <button
                      onClick={() => handelUpdate("Cash On Delivery")}
                      disabled={isDisable}
                      className="w-full bg-secondary hover:bg-secondary/95 text-white font-bold py-2.5 px-4 rounded-xl shadow-md transition active:scale-95 duration-100 disabled:bg-secondary/40 disabled:scale-100 disabled:cursor-not-allowed whitespace-nowrap text-sm"
                    >
                      Cash On Delivery
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => handelUpdate()}
                    disabled={isDisable}
                    className="w-full bg-secondary hover:bg-secondary/95 text-white font-bold py-2.5 px-4 rounded-xl shadow-md transition active:scale-95 duration-100 disabled:bg-secondary/40 disabled:scale-100 disabled:cursor-not-allowed text-sm"
                  >
                    Continue
                  </button>
                )}

                {isDisable && (
                  <p className="text-[10px] font-semibold text-rose-500 text-center mt-1">
                    Please fill out the shipping address fields to check out.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LicensePatient;
